module.exports = __webpack_public_path__ + "img/oasis.a5c637d2.png";